import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES } from '../../../common/types/monedaType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';

import ordenProduccionService from '../../../service/logistica/ordenProduccionService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModalVer from '../OrdenProduccion/FormModalVer';
import IngresoObservacionModal from './IngresoObservacionModal'

var referenciaCount = 1;


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        debugger
        this.state = {
            loadingSource: true,
            formValues: this.fetchEmptyFormValues(),
            filter: {
                ...FILTER,
                idEstadoOrdenProduccion: 0,
                estadosOrdenProduccion: [],
            },
            pagination: PAGINATION,
            visible: false,
            visibleVer: false,
            ingresoObservacionModal: {
                nombre: ''
            }
        }
    }

    async componentDidMount() {
        this._initPagination(this.state.filter, ordenProduccionService.paginacion);
        const ordenProduccionEstados = [
            { id: 0, nombre: '- TODOS -' },
            { id: 1, nombre: 'REGISTRADO' },
            { id: 2, nombre: 'ANULADO' },
            { id: 3, nombre: 'APROBADO' },
            { id: 5, nombre: 'IMPORTADO' },
            { id: 4, nombre: 'RECHAZADO' }
        ];

        this.setState({
            loadingSource: false,
            filter: {
                ...this.state.filter,
                estadosOrdenProduccion: ordenProduccionEstados
            },
        });
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleKeyUpInputSelect = (e) => {
        debugger
        //e.preventDefault();
        //if (e.keyCode === 13) {
        const filter = { ...this.state.filter, ...FILTER, idEstadoOrdenProduccion: e.key };
        this._handlePagination(filter);
        //}
    };

    handleClearFilters = () => {
        var filter = {
            serie: '',
            documento: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleVer = async (values) => {
        const response = await ordenProduccionService.obtenerPorId(values.id);
        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);

            for (var i = 0; i < response.ordenProduccionDetalles.length; i++) {
                var item = response.ordenProduccionDetalles[i];
                var oneProd = {
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv
                }

                formValues.listaComprobanteDetalle.push(oneProd);

            }

            for (var i = 0; i < response.ordenProduccionReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.ordenProduccionReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    nombreTipoComprobante: item.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            this.setState({
                visibleVer: true,
                formValues,
                //productoModal: {
                //    ...this.state.productoModal,
                //    selectedRowKeys: []
                //}
            });
        }
    }

    handleRechazar = async (values) => {
        dialog.confirm(`¿Desea rechazar la Orden de Produccion ${values.serie}-${values.documento}?`, async () => {
            debugger
            const emptyForm = this.fetchEmptyFormValues();
            emptyForm.iD = values.id;
            this.setState({
                visible: true,
                formValues: emptyForm,
                ingresoObservacionModal: {
                    ...this.state.ingresoObservacionModal
                }
            });
        });
    }

    handleCompletarRechazo = async (values, form) => {
        debugger
        var data = {
            idOrdenProduccion: values.id,
            codOrdenProduccionEstado: 'RE',
            observacionRechazado: values.observacionRechazo
        };
        console.log(data);
        var response = await ordenProduccionService.actualizarEstado(data);

        if (response.status === 200) {
            var empty = this.fetchEmptyFormValues();
            this.setState({ visible: false, formValues: empty });
            form.setFieldsValue(empty);
            form.resetFields();

            message.success('Registrado rechazado correctamente.');

            this._handlePagination(this.state.filter);
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
            return;
        }

        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');

    }

    handleAprobar = async (values) => {
        dialog.confirm(`¿Desea aprobar la Orden de Produccion ${values.serie}-${values.documento}?`, async () => {
            debugger
            var data = {
                idOrdenProduccion: values.id,
                codOrdenProduccionEstado: 'AP'
            };
            var response = await ordenProduccionService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });
                //form.setFieldsValue(empty);
                //form.resetFields();

                message.success('Registrado aprobado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    fetchEmptyFormValues = () => {
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: 0,
            idCliente: 0, //..........................................................OK
            idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: 'OP01', //............................................... OK
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoCliente: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            idRequerimiento: 0
        }
    };

    fetchEditFormValues = (value) => {

        return {
            id: value.ordenProduccion.id,
            idCliente: value.ordenProduccion.idEntidadProveedor, //..........................................................OK
            idEstablecimientoCliente: value.ordenProduccion.idEstablecimientoProveedor, //..........................................................OK
            idAlmacen: value.ordenProduccion.idAlmacen, //..........................................................OK
            idMoneda: value.ordenProduccion.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: value.ordenProduccion.idEstablecimiento,
            idProyecto: value.ordenProduccion.idProyecto,
            serie: value.ordenProduccion.serie, //............................................... OK
            documento: value.ordenProduccion.documento, //............................................... OK
            documentoCliente: value.ordenProduccion.documentoProveedor,
            fechaStr: value.ordenProduccion.fechaStr, //global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: value.ordenProduccion.fechaVencimientoStr, //......................................... OK
            diasVencimiento: value.ordenProduccion.diasVencimiento, //..........................................................OK
            tipoCambio: value.ordenProduccion.tipoCambio, //..........................................................OK
            observacion: value.ordenProduccion.observacion, //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: value.ordenProduccion.subTotal,
            sumaIgv: value.ordenProduccion.igv,
            sumaTotal: value.ordenProduccion.total,
            //almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            //vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            //detracciones: []
            proyectos: [],
            idRequerimiento: 0,
            nombreMoneda: value.ordenProduccion.nombreMoneda,
            nombreProyecto: value.ordenProduccion.nombreProyecto,
            nombreAlmacen: value.ordenProduccion.nombreAlmacen,
            proveedor: value.ordenProduccion.proveedor,
            direccionEstablecimiento: value.ordenProduccion.direccionEstablecimiento,
            nombreEstablecimientoSucursal: value.ordenProduccion.nombreEstablecimientoSucursal
        }
    }

    handleExportExcel = async () => {
        var response = await ordenProduccionService.excel(this.state.filter);
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de OdenProduccion.xlsx");
    }

    handleAnular = async (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var data = {
                idOrdenProduccion: values.id,
                codOrdenProduccionEstado: 'AN',
                observacionRechazado: ''
            };
            var response = await ordenProduccionService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });

                message.success('Registrado anulado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    render() {

        return (
            <div>
                <Header
                    title="Bandeja de Orden de Produccion"
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onKeyUpSearchSelect={this.handleKeyUpInputSelect}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onChange={this._handleChangePagination}
                    onVer={this.handleVer}
                    onRechazar={this.handleRechazar}
                    onAprobar={this.handleAprobar}
                    onAnular={this.handleAnular}
                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <IngresoObservacionModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleCompletarRechazo}
                />
            </div>
        );
    }
}